<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre" id="pgepubid00004"><span class="calibre1" id="Page_34" title="34"></span><span>Afternoon Session</span></h2>
<p class="pindent">MARSHAL: If it please the Tribunal, the Defendant Streicher is
absent from this session.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Witness, will you look again at the
document we were reading before the Court adjourned. Would you
look at the paragraph which commences “as everywhere else it is
extremely important to know where the enemy is and what he is
doing.” My Lord, I am not absolutely certain that I did not start
reading.</p>
<p class="pindent">THE PRESIDENT: Oh, yes, you had read that and the next one
and the one at the top of Page 3 in the English text. At least I think
you have. You read the one beginning “An important section.”</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Perhaps I can start the paragraph
commencing “An important section.” Have you got that?</p>
<p class="pindent">BOHLE: Yes.</p>
<div class="blockquote">
<p class="calibre3">LT. COL. GRIFFITH-JONES: “An important section of both
your work and that of your comrades must be industrial concerns,
business enterprises, <span class="it1">et cetera</span>. Not only can you spread
your propaganda very well in this way, but it is precisely in
such concerns that you can easily pick up information concerning
strange visitors. It is known that the enemy espionage
organizations are especially active in industrial circles, both
in gathering information and carrying out acts of sabotage.
Comrades with close connections with shipping and forwarding
companies are particularly suitable for this work. Naturally
you must be meticulous and cautious when selecting your
assistants.</p>
<p class="calibre3">“In this connection a reference to interstate organizations and
exchange organizations is relevant.”—I particularly want you
to note these next lines:</p>
<p class="calibre3">“It has been proved that these often use harmless activities as
camouflage and are in reality to be regarded as branches of
the Foreign Intelligence Department.”</p>
</div>
<p class="pindent">Witness, doesn’t that exactly describe the way in which the Auslands-Organisation
was carrying on its business? Read it again:</p>
<div class="blockquote">
<p class="calibre3">“It has been proved that these often use harmless activities as
camouflage and are in reality to be regarded as branches of
the Foreign Intelligence Department.”</p>
</div>
<p class="pindent">Doesn’t that fit in with the directions that this Landesgruppenleiter
of yours has been writing to his members in this document?
<span id="Page_35" title="35"></span></p>
<p class="pindent">BOHLE: On the contrary, I find that this is clear proof of the
fact that the organizations mentioned here were in a foreign espionage
service and not in the German espionage service. My interpretation
is the exact opposite of that of the British Prosecutor.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Are you not giving instructions
here, or is not your Landesgruppenleiter giving instructions, to carry
out counterespionage—the work that is carried on by the intelligence
service? Isn’t that what the writer is writing about so far?</p>
<p class="pindent">BOHLE: The letter, with which I am not personally familiar,
apparently instructs Germans abroad to turn in a report whenever
they encounter the intelligence service at work. I do not think that
any objection can be raised to that in time of war.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Very well. We will not go on
arguing about it. I understand that you know nothing about the
instructions which are contained in that letter. This is the first you
have ever seen or heard of it; is that right?</p>
<p class="pindent">BOHLE: No, this letter is new to me, and I do not know whether
it is true, for there is no original here.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: May I take it then that, of the
countries around Germany in which your organization worked, you
have no knowledge of the activities that they were carrying out in
Belgium? You have no knowledge of the activities that they were
carrying out in Norway, none about what they were doing in Spain,
and not very much about what they were doing in Romania either;
is that correct?</p>
<p class="pindent">BOHLE: No, that is not correct. Of course I knew of the activity
of these groups abroad; but the particular activity that the British
Prosecutor wishes to point out as the aim of the Auslands-Organisation
is not quite clear to me.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: If you had knowledge of any of
their activities—I understand from your evidence that you had none
of the activities about which your own Auslands-Organisation Yearbook
publishes a story. Both in Norway and Greece the activities
were recounted in those two stories. You knew nothing about them
at all; is that right?</p>
<p class="pindent">BOHLE: I did not know about the activity in Norway. I have
already testified to that effect. I was very familiar with the activity
in Greece which was along perfectly normal lines.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Very well. I want to leave that,
and I just want to ask you two questions about another matter. Am
I right in saying that the information—and I am not going to argue
with you now as to what type of information it was—but the information
that your organization sent back, was that passed on to the
Defendant Hess?
<span id="Page_36" title="36"></span></p>
<p class="pindent">BOHLE: Sometimes yes and sometimes no. It depended upon the
nature of the information. If it was information on foreign policy
it was, of course, sent to another office.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: You were in fact acting as a pool
of information, were you not? Let me explain myself: You were
forwarding information that you received, to the SS?</p>
<p class="pindent">BOHLE: Sometimes, yes; if not to the SS then probably...</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: To the Foreign Office?</p>
<p class="pindent">BOHLE: Sometimes also to the Foreign Office.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: And to the Abwehr, were you not?</p>
<p class="pindent">BOHLE: Very seldom, but it happened occasionally.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: You say very seldom. Did you not
have a liaison officer attached to your organization from the Abwehr?</p>
<p class="pindent">BOHLE: No. I had only one assistant who maintained an unofficial
connection with the Abwehr, if the occasion arose.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Perhaps we are talking about the
same gentleman. Did you not have a Captain Schmauss attached to
your head office in Berlin?</p>
<p class="pindent">BOHLE: Mr. Schmauss has never been a captain but he was a
political leader and honorary SS-leader. In the Army, I believe he
was a sergeant. Moreover, he did not come from the Abwehr; he
was chief of personnel of the Auslands-Organisation and his function
as liaison was purely unofficial.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: You say he was not a liaison officer
between your organization and the Abwehr?</p>
<p class="pindent">BOHLE: No, he was not an officer at all. He was not a member
of the Wehrmacht.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: I do not want to quibble with you
about his rank. Was he, in effect, whatever he was, acting in a
capacity of liaison between you and the Abwehr?</p>
<p class="pindent">BOHLE: Yes, that is correct.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Very well. Now, in addition to the
information that Hess obtained through your system of reporting,
that is, the Auslands-Organisation, did he also obtain information
from those organizations which were dealing with the Volksdeutsche,
that is to say, non-German citizens, racial Germans abroad who were
not members of your organization, because you allowed only German
citizens to become members of your organization. But others—Volksdeutsche,
I think you call them—did Hess receive information
from other sources about their activities?</p>
<p class="pindent">BOHLE: I could not say, because I did not discuss it with Hess,
and the affairs of the Volksdeutsche were entirely out of my field.
<span id="Page_37" title="37"></span></p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Dr. Karl Haushofer was for some
time in 1938 and 1939 president of the VDA, was he not?</p>
<p class="pindent">BOHLE: I believe so.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Which was an organization dealing
with the activities of the Volksdeutsche in foreign countries. Is that
correct?</p>
<p class="pindent">BOHLE: Yes, I believe so. I am not familiar with this field.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: And, as you know, Hess and Karl
Haushofer were great friends, were they not?</p>
<p class="pindent">BOHLE: Yes, that is correct.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Haushofer had been Hess’ pupil at
Munich University; did you know that?</p>
<p class="pindent">BOHLE: It was the other way around.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Do you not know that Hess received
information from Haushofer as to the activities of these other
organizations?</p>
<p class="pindent">BOHLE: No, I know nothing about it.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Well, now, I do not want to catch
you out. Is that your answer? Are you being honest to this Tribunal?</p>
<p class="pindent">BOHLE: No. I wanted to add that the Deputy of the Führer very
painstakingly separated the “Auslandsdeutsche,” that is, citizens of
the Reich who worked abroad, and the “Volksdeutsche,” and with
equal care he made certain that I should have nothing to do with
the question of Volksdeutsche. Therefore I knew nothing of these
matters.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Hess as Deputy to the Führer was
in fact in charge of all matters concerning Germanism abroad; was
he not?</p>
<p class="pindent">BOHLE: Yes, that is so, because he was born abroad. However,
to my knowledge, he did not take charge of these matters in his
capacity as Deputy to the Führer. I do not believe that there was
any connection.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Are you telling the Tribunal that
just because he was born in a foreign country he had charge of all
matters concerning Germanism abroad?</p>
<p class="pindent">BOHLE: I believe so, because any other Reichsleiter of the Party
might just as well have taken care of these matters. However, I
assume that Hess took over these functions simply because he was
familiar with foreign countries.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: I want to be quite clear. Whatever
the reason was, he in fact did have charge of them. That is your
evidence?
<span id="Page_38" title="38"></span></p>
<p class="pindent">BOHLE: Yes.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Now, I just want to remind you of
a passage in your interrogation in this building on the 9th of November.
Do you remember that you were interrogated on the 9th...</p>
<p class="pindent">BOHLE: [<span class="it1">Interposing.</span>]: September?</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: On 9 November last.</p>
<p class="pindent">BOHLE: November, yes.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: You were interrogated by a Lieutenant
Martin, the afternoon of that day.</p>
<p class="pindent">BOHLE: By Lieutenant Martin, yes.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Let me read a short extract from
the transcript of that interrogation and ask you whether, in fact, it
is correct. You were being asked about the information which came
back through the Auslands-Organisation.</p>
<div class="blockquote">
<p class="calibre3">“Question: ‘He would have to rely on you for his information
on matters of that kind?’</p>
<p class="calibre3">“Answer: ‘Not entirely; I think Hess had a great many connections
in Hamburg through which he obtained information
which he did not relay to me.’</p>
<p class="calibre3">“Question: ‘What were his connections in Hamburg?’</p>
<p class="calibre3">“Answer: ‘The shipping companies.’</p>
<p class="calibre3">“Question: ‘Rather like your Landesgruppenleiter instructions
in Romania?’</p>
<p class="calibre3">“Answer: ‘I think he knew a number of people there. I have
always been convinced that he knew them.’</p>
<p class="calibre3">“Question: ‘Is that Helferich?’</p>
<p class="calibre3">“Answer: ‘Helferich was one, but then there were many
people from whom he received information. I believe from
Professor Haushofer, his old teacher, with whom he was very
friendly. But he always made it a point not to inform us of
anything that concerned the Volksdeutsche; he said, “It is not
your affair at all.” ’ ”</p>
</div>
<p class="pindent">Is that correct?</p>
<p class="pindent">BOHLE: That is quite correct, yes.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: And as you have said it there, is
that a correct description of the position that Hess was in with
regard to information from abroad, from agents abroad? Does that
correctly state the facts as they were?</p>
<p class="pindent">BOHLE: So far as I can see, it is probably correct. I myself can
judge only to the extent to which the reports concerned the Auslands-Organisation.
About the others I can make only a guess; I
<span id="Page_39" title="39"></span>
cannot give definite information, because I was not acquainted
with them.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: I have no further questions. Perhaps
I might get the exhibits in order, the ones that I have referred to.</p>
<p class="pindent">The Yearbook of the Auslands-Organisation from which the
stories about Norway and Greece came, becomes Exhibit GB-284.
The two translations that you have are numbered Documents M-153
and M-156, both of which become Exhibit GB-284.</p>
<p class="pindent">The secret wireless telegram, which was Document Number
M-158, becomes Exhibit GB-285; and the letter from Landesgruppenleiter
Konradi, which was Document Number 3796-PS, becomes
Exhibit GB-286.</p>
<p class="pindent">BOHLE: May I add something to a point which was brought up
by the British cross-examination?</p>
<p class="pindent">THE PRESIDENT: Yes.</p>
<p class="pindent">BOHLE: May I begin?</p>
<p class="pindent">THE PRESIDENT: You may give a short explanation. You are
not here to make a speech.</p>
<p class="pindent">BOHLE: No, I do not want to make a speech. I merely wish to
say the following on the question of secret transmitters which was
brought up this morning: Although I am not familiar with the
technique of these secret transmitters, I assume that a secret transmitter
would be of use in a foreign country only if there were a
receiving set in Berlin.</p>
<p class="pindent">I am quite certain that to my knowledge there was never such a
receiving set, either in my office in Berlin or in any other office of
the Auslands-Organisation, and therefore I may assume that such a
receiving set did not exist.</p>
<p class="pindent">COLONEL JOHN HARLAN AMEN (Associate Trial Counsel for
the United States): Do you recall being interrogated on 11 September
1945, by Colonel Brundage?</p>
<p class="pindent">BOHLE: Yes.</p>
<p class="pindent">COL. AMEN: I want to read you a few questions and answers
from your interrogation and ask you whether you recall being asked
those questions and having made those answers:</p>
<div class="blockquote">
<p class="calibre3">“Question: ‘Now, when you started, your immediate superior
was who?’</p>
<p class="calibre3">“Answer: ‘Rudolf Hess, until 1941 when he left for England.’</p>
<p class="calibre3">“Question: ‘Who succeeded him?’</p>
<p class="calibre3">“Answer: ‘Martin Bormann. Martin Bormann automatically
succeeded Hess, but he did not really fill Hess’ position,
<span id="Page_40" title="40"></span>
because Hess had been born abroad in Egypt, while Martin
Bormann understood nothing about foreign affairs. He paid
no attention to them at all, but of course, he was my superior.’</p>
<p class="calibre3">“Question: ‘But he was nominally your chief?’</p>
<p class="calibre3">“Answer: ‘He was technically my chief, but he gave me no
orders, directives or similar instructions, because he did not
understand anything about these things.’</p>
<p class="calibre3">“Question: ‘So that everything that was done in your office,
you would say you were responsible for?’</p>
<p class="calibre3">“Answer: ‘Absolutely.’</p>
<p class="calibre3">“Question: ‘And you are willing to accept the responsibility
for that?’</p>
<p class="calibre3">“Answers ‘Naturally.’”</p>
</div>
<p class="pindent">Do you remember being asked those questions and having made
those answers?</p>
<p class="pindent">BOHLE: That is absolutely correct.</p>
<p class="pindent">COL. AMEN: And were those answers true when you made them?</p>
<p class="pindent">BOHLE: Absolutely true.</p>
<p class="pindent">COL. AMEN: And are they still true today?</p>
<p class="pindent">BOHLE: They are still true.</p>
<p class="pindent">COL. AMEN: So that you accept responsibility for everything
which your office was conducting, is that true?</p>
<p class="pindent">BOHLE: Yes, that is correct.</p>
<p class="pindent">COL. AMEN: Who was Von Strempel?</p>
<p class="pindent">BOHLE: Von Strempel was, I believe, counsellor to a secretary
of a legation (Gesandtschaftsrat) in the foreign office, but I do not
know him very well.</p>
<p class="pindent">COL. AMEN: Was he not the first secretary of the German
Embassy in the United States from 1938 until Pearl Harbor?</p>
<p class="pindent">BOHLE: I cannot say definitely. I knew him only slightly and
had absolutely no contact with him.</p>
<p class="pindent">COL. AMEN: Well, he was interrogated with respect to the
support of the German-American Bund by the Auslands-Organisation
prior to 1938, and I want to read you just one or two questions and
answers which he made and ask you whether they conform to your
understanding of the facts. Do you understand?</p>
<p class="pindent">BOHLE: Yes.</p>
<div class="blockquote">
<p class="calibre3">COL. AMEN: “Question: ‘Was the German-American Bund
supported by the Auslands-Organisation?’
<span id="Page_41" title="41"></span></p>
<p class="calibre3">“Answer: ‘I am positive that it was connected with the foreign
section of the Party. For example, the Bund received instructions
from the Party on how to build up their political organization,
how, where, and when to hold mass meetings and how
to handle their propaganda. Personally, I do not know whether
it received financial support.’ ”</p>
</div>
<p class="pindent">Does that conform with your understanding of the facts?</p>
<p class="pindent">BOHLE: No, that is a completely false representation. The Auslands-Organisation
gave no financial support whatever and had no
connection with the German-American Bund. I have stated that
clearly in many interrogations here in Nuremberg, and have signed
an affidavit to that effect.</p>
<p class="pindent">COL. AMEN: I know you have. So that if Von Strempel has
sworn that that is a fact, your testimony is that he was not telling
the truth. Is that correct?</p>
<p class="pindent">BOHLE: I am of the opinion that if Von Strempel was legation
secretary, or secretary of another office, he could not have known
of the matter and he therefore testified about something which was
not quite clear to him. In any event, what he said is not true.</p>
<p class="pindent">COL. AMEN: Are you familiar with the fact that in 1938 an
order was issued prohibiting members of the German embassies and
consulates to continue relations or connections with the Bund?</p>
<p class="pindent">BOHLE: It was a general order for German citizens abroad to
resign from the Bund if they were members. But as far as I know,
that order was issued some years previously about 1935 or 1936, by
the Deputy of the Führer upon my request.</p>
<p class="pindent">DR. SEIDL: I object to this question; it has no connection with
the evidence for which the witness Bohle was called. During his
direct examination he was not questioned on any subject which has
the slightest relation to the question of the activity of the German-American
Bund. I do not believe that this form of interrogation is
designed to test the witness, as it has not the slightest bearing on
the subject.</p>
<p class="pindent">COL. AMEN: It seems to me to have a very direct bearing on
whether or not this organization was engaged in espionage work
abroad and within the United States.</p>
<p class="pindent">THE PRESIDENT: Certainly; in the opinion of the Tribunal the
questions are perfectly proper.</p>
<p class="pindent">COL. AMEN: Is it not a fact that in spite of that order the foreign
section of the Nazi Party nevertheless continued to support the Bund?</p>
<p class="pindent">BOHLE: No, I was not aware of that and I consider it to be
impossible.
<span id="Page_42" title="42"></span></p>
<p class="pindent">COL. AMEN: Now I would like to read you one or two further
extracts from the interrogation of Strempel and ask you whether
these statements conform with your knowledge of the facts:</p>
<div class="blockquote">
<p class="calibre3">“Question: ‘Did the foreign section of the Party continue to
support the Bund after the order you mentioned before was
issued?’</p>
<p class="calibre3">“Answer: ‘I am sure that Mr. Draeger, consul in New York
City and representative of the foreign section of the Party,
did continue to have relations with Bund officials.’ ”</p>
</div>
<p class="noindent">Does that conform with your recollection of the facts?</p>
<p class="pindent">BOHLE: No. In my opinion, that does not correspond to the facts.
Naturally, I cannot say whether the consul, Dr. Draeger, maintained
his contacts against my order, but there was an imperative order to
withdraw completely from the Bund, because from the very beginning
I objected strenuously to the activities of the Bund and was
supported in my objections by the Deputy of the Führer.</p>
<p class="pindent">COL. AMEN: You were acquainted with Draeger, were you not?</p>
<p class="pindent">BOHLE: Yes.</p>
<p class="pindent">COL. AMEN: What was his position in the United States, insofar
as your organization was concerned?</p>
<p class="pindent">BOHLE: He was a liaison man (Vertrauensmann) of the Auslands-Organisation
for the individual Party members in the United States.</p>
<p class="pindent">COL. AMEN: He was what was known as a confidential agent,
was he not?</p>
<p class="pindent">BOHLE: No, he was not, naturally, but we had...</p>
<p class="pindent">COL. AMEN: And as a matter of fact, you called him a “confidential
agent” in your interrogation, did you not?</p>
<p class="pindent">BOHLE: No. I called him a “Vertrauensmann,” and this was
translated into “confidence man.” I did...</p>
<p class="pindent">COL. AMEN: Well, I will accept that correction. He was a confidence
man for your organization in the United States. Correct?</p>
<p class="pindent">BOHLE: Correct, yes, that is true.</p>
<p class="pindent">COL. AMEN: And in addition to him there were other confidence
men of your organization in the United States? Correct?</p>
<p class="pindent">BOHLE: Yes, correct.</p>
<p class="pindent">COL. AMEN: Will you tell the Tribunal what their names were
and where they were located?</p>
<p class="pindent">BOHLE: One was Wiedemann, consul general in San Francisco.
There was also Consul Dr. Gissling in Los Angeles and Consul Von
Spiegel in New Orleans I believe, but I do not know; perhaps it
was Boston. It was one of the two. I believe these are all.
<span id="Page_43" title="43"></span></p>
<p class="pindent">COL. AMEN: And each of those individuals made reports from
time to time which were forwarded to you through Draeger. Is that
not a fact?</p>
<p class="pindent">BOHLE: No, they made no reports to me. I cannot recall that I
ever saw a report from Wiedemann, Spiegel, or Gissling. That was
not their job.</p>
<p class="pindent">COL. AMEN: Draeger made the reports to you, did he not?</p>
<p class="pindent">BOHLE: Draeger made the reports to the Auslands-Organisation
in Berlin or to me personally. Mostly to my office.</p>
<p class="pindent">COL. AMEN: And contained in those reports were various items
of information collected by other confidential agents? Isn’t that
correct?</p>
<p class="pindent">BOHLE: I do not know, because I am not familiar with these
reports and I cannot say whether there was anything to report. We
had no Party organization in the United States, because it had been
dissolved by Rudolf Hess in April 1933.</p>
<p class="pindent">COL. AMEN: So you say; but you nevertheless had an individual
in Germany whose duty it was to read and pass upon these reports
from Draeger as they came in. Is that not a fact?</p>
<p class="pindent">BOHLE: So far as I know, and I believe my information is
correct; the reports that we received were of a purely technical
nature. We merely had few Party members in the United States
whose card index and membership fees had to be looked after in
order to preserve their privileges as Party members. Political
activity in the United States was forbidden and did not actually
exist.</p>
<p class="pindent">COL. AMEN: But I am suggesting to you that in spite of the
order the activities of your organization nevertheless continued.
Now, is it not a fact that there was an individual in your organization
in Germany who received these reports from the United
States regularly?</p>
<p class="pindent">BOHLE: It was my assistant, Mr. Grothe, who...</p>
<p class="pindent">COL. AMEN: I beg your pardon?</p>
<p class="pindent">BOHLE: It was my assistant, Mr. Grothe.</p>
<p class="pindent">COL. AMEN: Correct. Why didn’t you tell me that before when
I asked you about the individual who read these reports from the
United States as they came in?</p>
<p class="pindent">BOHLE: Please repeat the question. I did not fully understand it.</p>
<p class="pindent">COL. AMEN: Well, I will withdraw that question. After Grothe
received these reports from the United States regularly, to whom
did he report the substance of those reports?
<span id="Page_44" title="44"></span></p>
<p class="pindent">BOHLE: So far as I know, he usually kept them, because they
contained nothing of interest and he himself was not in a position
to use them. Mr. Grothe had an honorary position with us because
of his advanced age and took over this branch of the office because
it was of no importance at all in the Auslands-Organisation.</p>
<p class="pindent">COL. AMEN: So that you were in no position to know what was
contained in those reports? Is that correct?</p>
<p class="pindent">BOHLE: That is for the most part correct.</p>
<p class="pindent">COL. AMEN: So you do not know whether they were important
or not and you do not know whether they contained information
relative to espionage matters or not. Is that correct?</p>
<p class="pindent">BOHLE: I am sure that if they had contained such information,
Grothe would have submitted them to me.</p>
<p class="pindent">COL. AMEN: Well, outside of that, you have no knowledge of it
whatsoever. Is that correct?</p>
<p class="pindent">BOHLE: That is correct.</p>
<p class="pindent">COL. AMEN: Now, let me just read you one or two more excerpts
from the interrogation of Von Strempel:</p>
<div class="blockquote">
<p class="calibre3">“Question: ‘These relationships seem to have violated the order
you mentioned before. Did you report these violations to the
Foreign Office?’</p>
<p class="calibre3">“Answer: ‘Yes, several times. In reports that I drafted for
Thomsen when I was in the Embassy, we called the attention
of Berlin to the fact that this relationship to the Bund was
very detrimental... and stated that the continued support of
the Bund by the foreign section of the Party was harming
diplomatic relations with the United States.’</p>
<p class="calibre3">“Question: ‘What action was taken in Berlin to halt the activities
of which you complained?’</p>
<p class="calibre3">“Answer: ‘I know of no action.’ ”</p>
</div>
<p class="noindent">Does that conform to your knowledge of the facts?</p>
<p class="pindent">BOHLE: I have not the slightest idea of this report by Herr Von
Thomsen. This is the first time that I have heard of protests from
the Embassy in Washington regarding prohibited connections between
Dr. Draeger and the Bund.</p>
<p class="pindent">COL. AMEN: You know who Thomsen was, do you not?</p>
<p class="pindent">BOHLE: Thomsen was Chargé d’Affaires in Washington.</p>
<p class="pindent">COL. AMEN: And you know that from time to time various officials
of the Bund came over here and had conferences with representatives
of your organization and of the Führer, do you not?</p>
<p class="pindent">BOHLE: I have heard that they visited the Führer but they did
not visit me and we had no conferences of any description.
<span id="Page_45" title="45"></span></p>
<p class="pindent">COL. AMEN: I did not say with you. I said with representatives
of your office; perhaps your friend, Mr. Grothe?</p>
<p class="pindent">BOHLE: That might be possible but I cannot say definitely
because he did not report to me on this matter. They could not
have discussed any official matters with Grothe, because he knew
very well that I completely repudiated the activities of the German
Volksbund in America.</p>
<p class="pindent">COL. AMEN: In any event, however, you accept responsibility
for everything which was done in your organization. Correct?</p>
<p class="pindent">BOHLE: Naturally.</p>
<p class="pindent">THE PRESIDENT: Do either of the other Chief Prosecutors wish
to cross-examine? [<span class="it1">There was no response.</span>] Then, Dr. Seidl, you can
re-examine if you wish.</p>
<p class="pindent">DR. SEIDL: Witness, you have already answered a question that
I intended to ask you, that is, that there was no secret transmitter
in Germany which would have been in a position to broadcast secret
communications to foreign countries. I ask you now, did you yourself
have a transmitter in Germany?</p>
<p class="pindent">BOHLE: I myself had no transmitter.</p>
<p class="pindent">DR. SEIDL: Did the Auslands-Organisation have such a transmitter?</p>
<p class="pindent">BOHLE: I consider that to be absolutely impossible; if there had
been one, I would have known of it. I never saw one.</p>
<p class="pindent">DR. SEIDL: Is it correct that in order to communicate with Germans
overseas by radio you yourself did not use code on the German
network?</p>
<p class="pindent">BOHLE: That is correct.</p>
<p class="pindent">DR. SEIDL: You stated previously that the Deputy of the Führer,
Hess, was your immediate superior?</p>
<p class="pindent">BOHLE: Yes.</p>
<p class="pindent">DR. SEIDL: Were the directives given to you by the Deputy of
the Führer of a general nature, or did he go into the details of the
work of the Auslands-Organisation?</p>
<p class="pindent">BOHLE: The Deputy of the Führer gave only general directives
and left all the details to me because I had his complete confidence.
In his general directives he impressed upon me repeatedly in the
sharpest terms the fact that it was my duty to avoid any measures
by the Auslands-Organisation that might be detrimental to foreign
relations.</p>
<p class="pindent">DR. SEIDL: I have no further questions.</p>
<p class="pindent">THE PRESIDENT: The witness can retire.</p>
<p class="pindent">[<span class="it1">The witness left the stand.</span>]
<span id="Page_46" title="46"></span></p>
<p class="pindent">DR. SEIDL: Your Honors, before I go on to my next witness—that
is the witness Strölin—I should like to submit the suggestion
or rather the application to the Tribunal that the affidavit of the
witness Gaus be handled in the same way as the interrogation of
the witness Bohle. Gaus has already been admitted as a witness for
another defendant. However, the Defense Counsel for the other defendant
waived his right to call this witness. The situation is the
same as it was in the case of Bohle; therefore it would be preferable,
in my opinion, to hear the witness Gaus now and to read his
sworn statement to him during his examination as has been done in
other cases, for instance in the case of Blaha.</p>
<p class="pindent">THE PRESIDENT: Has the affidavit been translated yet and
submitted in the various languages to the Chief Prosecutors?</p>
<p class="pindent">DR. SEIDL: I do not know whether the translation is complete.
At any rate, this noon I submitted six copies of the affidavit to the
Translation Division.</p>
<p class="pindent">THE PRESIDENT: Can you tell me, Sir David or Colonel
Pokrovsky?</p>
<p class="pindent">SIR DAVID MAXWELL-FYFE: My Lord, I have not seen this
affidavit, and, My Lord, with regard to the last one, we got it
hurriedly translated into English, but it was only by the kindness
of my Soviet colleagues, who allowed the matter to go on without a
Russian translation and left it to my delegation to deal with, that
the matter went on. Otherwise, my Soviet colleagues would have
asked the Tribunal to have it put back.</p>
<p class="pindent">It is very difficult when these affidavits are sought to be put in
at the last minute without having given us a chance of seeing them.</p>
<p class="pindent">THE PRESIDENT: Perhaps Colonel Pokrovsky could tell me
whether he has seen this affidavit or had it translated yet.</p>
<p class="pindent">COLONEL Y. V. POKROVSKY (Deputy Chief Prosecutor for the
U.S.S.R.): Members of the Tribunal, I fully share the viewpoint of
Sir David Maxwell-Fyfe. It appears to me absolutely unacceptable
to have this document presented immediately to the Tribunal.</p>
<p class="pindent">If I understood Sir David Maxwell-Fyfe correctly, he did not
receive this affidavit. The Soviet delegation is in the same position.
Besides, I would like to remind you that the question of this witness
has already been discussed, that it has been definitely solved, and it
seems to me there are no grounds for a further revision of this
question.</p>
<p class="pindent">THE PRESIDENT: Dr. Seidl, the Tribunal considers that the
course which must be taken is that that affidavit must be translated
and submitted to the Tribunal for their consideration, for this
witness was allowed to the Defendant Ribbentrop, I think, and then
<span id="Page_47" title="47"></span>
he withdrew his application for the witness. You have not applied
for the witness Gaus, and I would point out to you and to the other
counsel for the defendants that it is very inconvenient that documents
of this sort—after all the question of witnesses and documents
has been thoroughly gone into by the Tribunal—should be presented
at the last moment and without any translation whatever. But we
will not go into it now, and it must be translated and submitted to
the Tribunal in the three languages.</p>
<p class="pindent">DR. SEIDL: Perhaps I might make one short remark in regard
to the last point. Up to now I was always under the impression that
a formal application to call a witness would not be necessary in the
case of a witness who has already been admitted by the Tribunal
for another defendant. That was undoubtedly so in the case of Gaus
who was named as a witness for the Defendant Von Ribbentrop.
Consequently I had no reason to make a formal application, since
I would have the opportunity to interrogate the witness in cross-examination
anyhow.</p>
<p class="pindent">I have just been informed by counsel for the Defendant Von
Ribbentrop that, as his representative said last Saturday, he will
forego calling the witness Gaus, and now I, in turn, apply to call
Ambassador Dr. Gaus as witness regarding the statements in his
sworn affidavit.</p>
<p class="pindent">THE PRESIDENT: I do not know what you mean by saying you
call him. You can apply to call him if you like, but you do not call
him until you apply.</p>
<p class="pindent">DR. SEIDL: Yes, Sir.</p>
<p class="pindent">THE PRESIDENT: When we have seen this document, we will
determine the question.</p>
<p class="pindent">DR. SEIDL: The next witness admitted by the Tribunal for the
Defendant Hess is the witness Karl Strölin. In order to save time I
have also prepared an affidavit for this witness, and I ask the Tribunal
to inform me whether we will follow the same procedure
with this witness as with the witness Bohle, or whether the Prosecution
agree that only the affidavit should be presented.</p>
<p class="pindent">THE PRESIDENT: Have they seen the affidavit?</p>
<p class="pindent">DR. SEIDL: I gave the affidavit to the Prosecution this morning.</p>
<p class="pindent">SIR DAVID MAXWELL-FYFE: I have got an English translation
of the affidavit. There are one or two questions the Prosecution
want to put to the witness, so I suggest that the most convenient
course would be if Dr. Seidl did as he did with the last witness, to
read the affidavit, and then after the affidavit is read, the few
questions that the Prosecution desire to be put can be put to him.</p>
<p class="pindent">THE PRESIDENT: Yes, very well.
<span id="Page_48" title="48"></span></p>
<p class="pindent">COL. POKROVSKY: I must report to you, Mr. President, that
as far as this document is concerned, the Defense Counsel has
violated the procedure you have established; the Soviet Prosecution
received this affidavit only a very short time ago—about 1 or 2 hours
ago—and it was not received by us in Russian but in English. Therefore,
I had the opportunity of familiarizing myself with it only very
slightly, and I ask to have the presentation of this document postponed
until such time when the order of the Tribunal is complied
with, in other words, not until we have received our document in
Russian.</p>
<p class="pindent">THE PRESIDENT: But, Colonel Pokrovsky, in the interest of the
time of the Tribunal, wouldn’t it be better to get on with it now?
Sir David has apparently seen the affidavit and read it in English,
and if he is satisfied upon that, wouldn’t it be better to go on with
it now rather than to postpone it?</p>
<p class="pindent">You see, Dr. Seidl has actually been allowed this witness, so that
it is only a question of time, doing it by way of an affidavit when
he can call him, and he can then ask him questions.</p>
<p class="pindent">COL. POKROVSKY: I must repeat that I have familiarized
myself with this document very slightly. As far as I can understand,
it is of no particular interest to the Soviet Delegation; it is of greater
interest to the British Delegation...</p>
<p class="pindent">THE PRESIDENT: Colonel Pokrovsky, you see the witness was
allowed to Dr. Seidl. Therefore, Dr. Seidl could have put him on the
witness box and could have asked him questions, and the only reason
for doing it by way of an affidavit is to get the matter more clearly
and more quickly. So if we were to order that this affidavit was not
to be used, we should then have Dr. Seidl asking the witness questions,
and probably, I am afraid, taking up rather longer than it
would to read the affidavit, and you would not object to that.</p>
<p class="pindent">COL. POKROVSKY: Perhaps the Tribunal would find it advisable
to have Dr. Seidl ask the witness those questions which have
already been answered in the affidavit? It seems to me that that
would give us an opportunity to reconcile this contradiction, especially
since there are only a few questions, and the first three, as far
as I can understand, are mostly of a historical nature and connected
with the organization of the Institute in Stuttgart in 1917.</p>
<p class="pindent">THE PRESIDENT: Colonel Pokrovsky, I have not read the affidavit
yet so I am afraid I am not in a position to present the question
which you wish me to present.</p>
<p class="pindent">COL. POKROVSKY: All right, I withdraw my objection.</p>
<p class="pindent">THE PRESIDENT: Call your witness then now.</p>
<p class="pindent">[<span class="it1">The witness Strölin took the stand.</span>]
<span id="Page_49" title="49"></span></p>
<p class="pindent">What is your name?</p>
<p class="pindent">KARL STRÖLIN (Witness): Karl Strölin.</p>
<p class="pindent">THE PRESIDENT: Will you repeat this oath after me: “I swear
by God—the Almighty and Omniscient—that I will speak the pure
truth—and will withhold and add nothing.”</p>
<p class="pindent">[<span class="it1">The witness repeated the oath in German.</span>]</p>
<p class="pindent">THE PRESIDENT: You may sit down if you wish.</p>
<p class="pindent">DR. SEIDL: Witness, you were last Lord Mayor of the City of
Stuttgart; is that correct?</p>
<p class="pindent">STRÖLIN: Yes.</p>
<p class="pindent">DR. SEIDL: In this capacity were you also Honorary President
of the German Auslands-Institut?</p>
<p class="pindent">STRÖLIN: Yes.</p>
<p class="pindent">DR. SEIDL: You signed a sworn affidavit this morning which I
shall now read to you.</p>
<div class="blockquote">
<p class="calibre3">“1. The German Auslands-Institut was founded in Stuttgart
in the year 1917. The fact that Stuttgart was chosen as the
seat of this institute is connected with the fact that the
Swabian district has always furnished a particularly high
percentage of emigrants. That is precisely why there arose in
Stuttgart the need to create an institution for the purpose of
preserving the national ties between the old and the new
homeland. The German Auslands-Institut was to serve this
purpose. It had the following aims:</p>
<p class="calibre3">“(a) Scientific research on Germanism in the world.</p>
<p class="calibre3">“(b) Maintaining cultural connections with the emigrants.</p>
<p class="calibre3">“(c) Informing the people at home about Germanism abroad
and about foreign countries.</p>
<p class="calibre3">“For scientific research the German Auslands-Institut had a
library of more than one hundred thousand volumes on folklore
and an archive for newspaper files concerning Germanism
abroad. For this purpose nearly all newspapers which were
published abroad in the German language and a large number
of newspapers in foreign languages were subscribed to and
their contents evaluated. An extensive collection of pictures
was in one filing room. As the Germans abroad became increasingly
interested in the homeland, genealogical research
took on ever greater proportions.</p>
<p class="calibre3">“In addition to its activities of collecting and registering, the
German Auslands-Institut also had advisory and representative
functions. The question of emigration was also a subject
for consultation for a long time. This required that the German
Auslands-Institut be informed regarding the living
<span id="Page_50" title="50"></span>
conditions and the possibility of finding employment in the
individual areas favored by emigrants. The records of the
German Auslands-Institut were placed at the disposal of the
various offices and organizations upon request. The representative
activities of the German Auslands-Institut consisted
mainly in organizing exhibitions. The center of this activity
was the Museum of Germandom Abroad, in Stuttgart.</p>
<p class="calibre3">“The scientific work of the German Auslands-Institut found
expression particularly in the books, magazines, and calendars
about the homeland which it published. The connections with
the Germans abroad were maintained by sending out such
publications. The guiding thought of the German Auslands-Institut
in its relations with the Germans abroad was that
these Germans abroad were to be the connecting links between
nations in order to strengthen mutual understanding and the
desire for co-operation. They were to be the envoys of friendship
between their old and their new homeland.</p>
<p class="calibre3">“As President of the German Auslands-Institut, I particularly
emphasized this thought in the speech which I made at Madison
Square Garden in New York City in October 1936 on the
occasion of German Day. Moreover the German Auslands-Institut
had no agencies or representatives abroad acting as
liaison for these corresponding members. Direct or individual
care for Germans abroad was not the task of the German Auslands-Institut.
The welfare of German nationals abroad was
taken care of by the Auslands-Organisation of the NSDAP.
Relations with the Volksdeutsche were maintained by the
Volksbund für das Deutschtum im Ausland (League For Germans
Abroad).</p>
<p class="calibre3">“2. The German Auslands-Institut never engaged in any activities
which could be termed Fifth Column activities. No one
has ever made a request of this nature to me or to the Institut.</p>
<p class="calibre3">“3. Rudolf Hess, the Deputy of the Führer, did not exert any
influence on the activities of the Institute. He issued no directives
or instructions which could have induced the Institute
to undertake any activity along the lines of Fifth Column
work.”</p>
</div>
<p class="noindent">Witness, are these statements correct?</p>
<p class="pindent">STRÖLIN: These statements are correct.</p>
<p class="pindent">DR. SEIDL: I have at the moment no further questions to direct
to the witness.</p>
<p class="pindent">THE PRESIDENT: Do any of the defendants’ counsel wish to ask
any questions of this witness?
<span id="Page_51" title="51"></span></p>
<p class="pindent">DR. OTTO FREIHERR VON LÜDINGHAUSEN (Counsel for
Defendant Von Neurath): Witness, with the permission of the Tribunal
I should like to ask you a few questions.</p>
<p class="pindent">First, from when to when were you Lord Mayor of Stuttgart?</p>
<p class="pindent">STRÖLIN: From 1933 until the end of the war.</p>
<p class="pindent">DR. VON LÜDINGHAUSEN: And how long have you known
the Defendant Von Neurath? What was his position at that time and
what was his reputation?</p>
<p class="pindent">STRÖLIN: I have known Herr Von Neurath since the first World
War. At that time, at the end of the first World War, he was Chief
of the Cabinet of the King of Württemberg, and his reputation was
excellent. In my capacity as Lord Mayor I met Herr Von Neurath
frequently. In 1938 Von Neurath became an honorary citizen of the
city of Stuttgart.</p>
<p class="pindent">DR. VON LÜDINGHAUSEN: Did you enter in still closer relations
with him later when he returned from Czechoslovakia?</p>
<p class="pindent">STRÖLIN: When he returned from Czechoslovakia Herr Von
Neurath retired to his estate of Leinfelden in the vicinity of Stuttgart,
and here I had closer and more active connection with him.</p>
<p class="pindent">DR. VON LÜDINGHAUSEN: What do you know about his ancestry,
his family, his education, his personality, in general?</p>
<p class="pindent">STRÖLIN: Von Neurath comes from an old Swabian family. His
father was Lord Chamberlain of the King of Württemberg. His
grandfather and his great-grandfather were ministers. Von Neurath
was very much respected as a high-minded character, a distinguished
personality, always ready to help, extraordinarily humane, very
conscientious, straightforward and frank.</p>
<p class="pindent">DR. VON LÜDINGHAUSEN: During his activity as Foreign
Minister and possibly later, did you have an opportunity to discuss
politics with him and particularly his views on foreign policy?</p>
<p class="pindent">STRÖLIN: Von Neurath repeatedly discussed these matters with
me, but of course, only in general terms. As Reich Foreign Minister
he was convinced that Germany would succeed in getting by peaceful
means the place in the world which she deserved. He rejected any
other way. He strove to build up and strengthen relations of mutual
confidence with other European powers, particularly with England.
He was convinced that it was precisely in this field that he had done
everything possible.</p>
<p class="pindent">Later, I had occasion to examine with him Henderson’s book <span class="it1">Two
Years with Hitler</span>, which particularly emphasized how extremely
popular Von Neurath had been in London at that time. I recall that
we also discussed the sentence written by Henderson, that he acknowledged
Von Neurath’s honest devotion to peace and to peaceful
<span id="Page_52" title="52"></span>
and friendly relations with England. Von Neurath was also greatly
concerned with the cultivation of better relations with the United
States. I recall that he discussed the subject with me after my trip
to America and said that I had done well to emphasize in my various
speeches Germany’s desire for friendship with the United States. I
also remember how severely Von Neurath criticized the tone of
Hitler’s speech made in the beginning of 1939 in reply to Roosevelt’s
message. He said at that time that the international tension had
been increased by that speech. Then Von Neurath spoke of the
Munich Agreement, in which he had been an active participant.
Later he very frequently spoke of the tragedy that was implicit in
the fact that, despite all efforts, the relation between England and
Germany had not remained one of continuing confidence. He pointed
out how tragic it was for Europe and for the world. All my conversations
with Von Neurath convinced me that he desired an understanding
and a peaceful settlement, and that he would never have
pursued a policy that might lead to war.</p>
<p class="pindent">DR. VON LÜDINGHAUSEN: What were the reasons for his
appointment as an honorary citizen of Stuttgart? This happened
after he resigned his office as Reich Foreign Minister, did it not?</p>
<p class="pindent">STRÖLIN: He was appointed in 1938, on the occasion of his 65th
birthday on 2 February 1938. This appointment was to express to
Von Neurath the gratitude and appreciation not only of the people
of Stuttgart but of all Swabia for his manifest love of peace and the
calm and prudence with which he had conducted foreign affairs. It
was also a token of respect for his honest and incorruptible character.</p>
<p class="pindent">DR. VON LÜDINGHAUSEN: Witness, the British Prosecution
assert that Herr Von Neurath repeatedly assured foreign governments
or their representatives that Germany had no military or
aggressive intentions toward these states, but that these assurances
were, in fact, given for the sake of appearances, in order to lull
these states into a false sense of security, because even then Von
Neurath knew and approved of the fact that Hitler actually had
aggressive intentions toward these states.</p>
<p class="pindent">From your knowledge of his personality do you consider Von
Neurath capable of such infamy?</p>
<p class="pindent">STRÖLIN: No, I do not consider him capable of such action.</p>
<p class="pindent">DR. VON LÜDINGHAUSEN: Did Herr Von Neurath inform you,
at the time, of his resignation from his position as Foreign Minister?</p>
<p class="pindent">STRÖLIN: By chance, I was with Von Neurath in the Foreign
Ministry on 4 February 1938 at the very moment when his resignation
was accepted. He described how this resignation came about.
He said that until the end of the year 1937 he had been convinced
that Hitler was completely in sympathy with the foreign policy
<span id="Page_53" title="53"></span>
which he was pursuing and that Hitler as well as himself had not
wanted to chance an armed conflict, but at the end of 1937 Hitler
had altogether unexpectedly changed his attitude; he had suddenly
struck a different note, and it was impossible to decide whether it
was to be taken seriously. Von Neurath went on to say that in a
personal conversation with Hitler he had attempted to persuade
him to give up this altered view, but that he had the impression
that he had lost his influence over Hitler, and this prompted him to
submit his resignation.</p>
<p class="pindent">DR. VON LÜDINGHAUSEN: After, or rather simultaneously with
his discharge from the foreign ministry, Von Neurath was appointed
President of the Secret Cabinet Council. Do you know anything
about this appointment—how and why he received it and what he
did in this capacity?</p>
<p class="pindent">STRÖLIN: He received this appointment as President of the
Secret Cabinet Council at the same time that his resignation was
accepted, but this Cabinet never convened; this was also true of the
Reich Cabinet. The Secret Cabinet was to be convened by Hitler
personally, and Hitler had simply not done this. Von Neurath believed
later that he had been appointed to this post as president only
in order to conceal from foreign countries that the former Foreign
Minister no longer had any influence on the policy of the Reich.</p>
<p class="pindent">THE PRESIDENT: Dr. Lüdinghausen, I do not see how this witness
can know whether the Secret Cabinet Council was ever called.
In any event we have already heard it from Göring, and presumably
we shall hear it again from the Defendant Von Neurath, in which
case it is grossly cumulative. I do not think we should waste the
time of the Tribunal with it.</p>
<p class="pindent">DR. VON LÜDINGHAUSEN: Did you occasionally speak to Von
Neurath regarding his attitude and relations toward the Nazi Party?</p>
<p class="pindent">STRÖLIN: Von Neurath’s attitude toward the Party was critical
and disapproving; at first he disapproved and waited to see what
would develop. His relations with the Party were bad. The Party
was of the opinion that Von Neurath was not a National Socialist.</p>
<p class="pindent">DR. VON LÜDINGHAUSEN: Did you ever discuss with him the
policy of the Nazis toward the Christian churches, that is, the
Catholic and the Protestant Church?</p>
<p class="pindent">STRÖLIN: Von Neurath was a faithful Christian and disapproved
of the policy of the Party toward the Christian churches. He particularly
supported Bishop Bohr’s efforts to maintain freedom of
religion. He repeatedly used his influence to see to it that seminaries
which had been requisitioned were released. Following a discussion
with Von Neurath I visited Minister for Churches Kerrl personally
and discussed with him the question of the policy toward the Church.
<span id="Page_54" title="54"></span>
I discovered that Minister for Churches Kerrl was making every
effort to represent and carry out the ideas of positive Christianity.
However, he did not succeed because his work was continually
sabotaged, particularly by Himmler and Bormann.</p>
<p class="pindent">DR. VON LÜDINGHAUSEN: Later, when Herr Von Neurath
retired to his estate of Leinfelden, did you discuss his activities as
Reich Protector with him?</p>
<p class="pindent">STRÖLIN: Von Neurath said that he took the post as Reich
Protector in Bohemia and Moravia most unwillingly, and that he
had refused it twice, but finally decided that he must make this
sacrifice. He believed that it was precisely there that he could act
as an intermediary and bring about reconciliation. He had personal
difficulties with Himmler and Frank; he told me of his efforts to
gain better treatment for the Czechs, and of the protests which he
made to Hitler in vain. Once, when I visited Von Neurath in Prague,
I was invited to visit President Hacha, who told me emphatically
how pleased he was that Von Neurath had been sent to Bohemia and
Moravia, for he enjoyed fullest confidence and performed in every
respect a conciliatory function. Von Neurath told me that he was
recalled and replaced because in his treatment of the Czechs he was
too mild for the Führer, who preferred a particularly trustworthy
SS-leader in that position.</p>
<p class="pindent">DR. VON LÜDINGHAUSEN: Who was to be appointed to
that post?</p>
<p class="pindent">STRÖLIN: That was Heydrich.</p>
<p class="pindent">DR. VON LÜDINGHAUSEN: Was that Herr Von Neurath’s reason
for resigning?</p>
<p class="pindent">STRÖLIN: Evidently.</p>
<p class="pindent">DR. VON LÜDINGHAUSEN: Now, Von Neurath was also an
Honorary Gruppenführer of the SS. Did he tell you how he attained
this—let us say—honor?</p>
<p class="pindent">STRÖLIN: He told me that he was appointed honorary leader of
the SS without having been consulted. When he asked the reason,
Hitler told him that Mussolini was soon to pay a visit and that he,
Hitler, wanted everyone in his attendance to wear a uniform. Since
Von Neurath had no uniform he appointed him an honorary leader
of the SS. Von Neurath said he did not intend to become one of
Himmler’s subordinates. Thereupon Hitler told him that that was
not necessary; it was merely a question of wearing a uniform.</p>
<p class="pindent">DR. VON LÜDINGHAUSEN: What was Herr Von Neurath’s
attitude toward war?</p>
<p class="pindent">STRÖLIN: On the first day of the war I saw Von Neurath to the
railroad station. He was depressed and rather dismayed. He called
<span id="Page_55" title="55"></span>
the war a terrible disaster, a gamble with the existence of the nation.
He said that all his work from 1932 to 1938 had thereby been destroyed.
I understood that during the war he saw the Führer
occasionally, and on each such occasion he used the opportunity to
ask Hitler to consider the idea of peace. That he, Neurath...</p>
<p class="pindent">THE PRESIDENT: How can the witness say this? He was not
present at these meetings; how can the witness tell us what the
Defendant Von Neurath said to the Führer?</p>
<p class="pindent">DR. VON LÜDINGHAUSEN: As you will understand, that is
what the defendant told him. That was told the witness by the
defendant directly.</p>
<p class="pindent">STRÖLIN: Von Neurath told me so repeatedly. He told me...</p>
<p class="pindent">THE PRESIDENT: It will be all extremely cumulative.</p>
<p class="pindent">DR. VON LÜDINGHAUSEN: I do not believe so. The witness
himself needs only to corroborate this to the Prosecution.</p>
<p class="pindent">THE PRESIDENT: Dr. Lüdinghausen, the Tribunal imagines that
the Defendant Von Neurath will give this evidence himself, and the
Tribunal does not wish to hear evidence from witnesses that was
told to them.</p>
<p class="pindent">DR. VON LÜDINGHAUSEN: Very well, I shall dispense with
any further questions along those lines. I should like to ask only
one more question.</p>
<p class="pindent">[<span class="it1">Turning to the witness.</span>] Did not Von Neurath, with you and
other people, make an effort to put an end to the war and to the
Hitler regime, or at least consider the possibility of doing so?</p>
<p class="pindent">Now these are facts that the witness knows from his own observation.</p>
<p class="pindent">STRÖLIN: Von Neurath discussed this question with me on
several occasions after his return from Prague. He tried particularly
to bring about a meeting of the Reich Cabinet, as did the other
ministers, but he did not succeed, since Hitler disapproved of this
Reich Cabinet as a “defeatists’ club.” As a preliminary step for
ending the war Von Neurath tried to bring about a change of
ministers and the appointment of a Reich Chancellor, which was also
widely demanded. This also failed. During the year 1943 Neurath
became more and more convinced...</p>
<p class="pindent">THE PRESIDENT: This is the same thing over again—nothing
about what Von Neurath did but all about what Von Neurath said
to this witness.</p>
<p class="pindent">DR. VON LÜDINGHAUSEN: I beg your pardon; these are only
preliminary remarks to clarify what is to follow.</p>
<p class="pindent">THE PRESIDENT: I thought you said you had one last question?
<span id="Page_56" title="56"></span></p>
<p class="pindent">DR. VON LÜDINGHAUSEN: Yes, we come to that now. The
question shows the attempts he made to carry out his intentions.</p>
<p class="pindent">STRÖLIN: When Von Neurath failed in his attempts at reform,
that is, when he saw that it had miscarried and that Hitler’s attitude
was negative and intransigent, Von Neurath came to the conviction,
at the beginning of 1944, that the saving of Germany from complete
destruction must not be wrecked because of Hitler. He considered
the question of how to speak to Hitler once more and persuade him
to end the war. He thought of Field Marshal Rommel and asked me
to discuss the matters with him. Rommel was at that time very
popular in Germany and abroad, and Von Neurath believed that due
to the position he held, Rommel was the right person to replace
Hitler, if necessary. In the beginning of March 1944, I went to Field
Marshal Rommel and discussed the matter with him. Rommel was
just as critical of the situation. I knew him from the first World
War, so that I could speak to him frankly. He was also of the opinion
that if the war could not be won on a military basis, unnecessary
bloodshed and senseless destruction...</p>
<p class="pindent">THE PRESIDENT: Dr. Lüdinghausen, we really do not want all
this conversation between this witness and Rommel. We do not want
it. We will not hear the conversation between this witness and
Rommel.</p>
<p class="pindent">DR. VON LÜDINGHAUSEN: Nor do I want the witness to discuss
this matter.</p>
<p class="pindent">THE PRESIDENT: Why don’t you stop him then? Why don’t you
stop him?</p>
<p class="pindent">DR. VON LÜDINGHAUSEN: I did not want to hear it from the
defendant himself, but from the person who was employed by the
defendant to take these steps. That in my opinion has more weight
than if the defendant makes the statement himself. That is why I
asked the witness about it. But it is almost finished now.</p>
<p class="pindent">THE PRESIDENT: When we come to the defendant then we will
not hear him on these subjects.</p>
<p class="pindent">DR. VON LÜDINGHAUSEN: No, that is not intended—moreover,
as far as I know, the matter will be finished with just a few words.
Please, Witness.</p>
<p class="pindent">STRÖLIN: Upon Von Neurath’s instigation, Rommel wrote a
letter to Hitler saying that because of the military situation he
believed that it would not be possible to continue the war, and that
he, Rommel, suggested to Hitler that he start political negotiations.
Consequently, as he told me, after his accident Rommel fell from
favor for this reason, and thus Von Neurath’s attempt to end the
war with Rommel’s aid also failed.
<span id="Page_57" title="57"></span></p>
<p class="pindent">DR. VON LÜDINGHAUSEN: And then came 20 July and soon
afterwards the end.</p>
<p class="pindent">I have no more questions, Mr. President.</p>
<p class="pindent">THE PRESIDENT: The Tribunal will adjourn.</p>
<h3 class="calibre17 sigil_not_in_toc" id="pgepubid00005">[<span class="it1">A recess was taken.</span>]</h3>
<p class="pindent">THE PRESIDENT: Do any of the other defendants’ counsel want
to ask questions of this witness?</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: May the witness be handed GB-262
(Document Number 3258-PS). My Lord, that is the same document
of which an extract has already been handed up to the Tribunal
while I was cross-examining the last witness.</p>
<p class="pindent">Witness, I want to be quite clear as to what you say about the
Deutsches Auslands-Institut. Do you say that that institute had no
connection with either Hess or the Auslands-Organisation?</p>
<p class="pindent">STRÖLIN: The Deutsches Auslands-Institut had no connection
with Hess. The connection with the Auslands-Organisation was due
to the fact that the Auslands-Organisation had its meetings at
Stuttgart.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: So that the fact that the Auslands-Organisation
and the Deutsches Auslands-Institut both had their
meetings at Stuttgart, that is the only connection between the two
organizations; is that so?</p>
<p class="pindent">STRÖLIN: The Auslands-Organisation, to my knowledge, did not
consult the German Auslands-Institut on practical matters, for it
had its own collection of material. The Auslands-Organisation was,
as far as I know, created in the year ’32, and...</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Now, I do not want to stop you,
but if you can answer my question “yes” or “no” it will save us all
a great deal of time. I will repeat my question in case you are not
quite clear about it. Do you say that the fact that both those organizations
held their meeting in Stuttgart is the only connection
between the two? Now you can answer that “yes” or “no.”</p>
<p class="pindent">STRÖLIN: I cannot answer that with “yes” or “no.” I must say
that the connecting link was the fact that Stuttgart was the city of
foreign Germans and so to speak the representative of Germans
abroad, because of its past history.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Do you read English?</p>
<p class="pindent">STRÖLIN: A little.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Will you look at Page 461 of the
book that you have? At the bottom of Page 461 you will see
<span id="Page_58" title="58"></span>
reproduced a copy of an article from the <span class="it1">Stuttgarter Neues Tagblatt</span>
of 21 September 1933.</p>
<p class="pindent">The Tribunal will find the extract on Page 4 of the translation.</p>
<p class="pindent">That article describes the annual meeting of your institution,
after its reorganization in 1933 when the Nazi Party came to power.
I want to read just four short extracts from that article 2 and ask
you for your comments.</p>
<div class="blockquote">
<p class="calibre3">“The chairman of the Deutsches Auslands-Institut, Lord
Mayor, Dr. Strölin, opened the celebration.”</p>
</div>
<p class="pindent">That is yourself presumably; is that so?</p>
<p class="pindent">STRÖLIN: Yes.</p>
<div class="blockquote">
<p class="calibre3">LT. COL. GRIFFITH-JONES: “Among those present, he greeted
in particular, Minister President and Minister of Religion
in Württemberg, Mergenthaler, as the representative of the
supervisory authorities; General Haushofer of Munich as
representative of Rudolf Hess, who has been entrusted by the
Führer with the supreme direction of all matters concerning
Germans in foreign countries....”</p>
</div>
<p class="pindent">Did you say that?</p>
<p class="pindent">STRÖLIN: I cannot remember having said that. Haushofer was
for me the representative of the VDA, and I cannot conceive how
he could have been the deputy of Hess at this occasion. However, it
is probably true.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Do you think the Tribunal is safe
in taking it that the <span class="it1">Stuttgarter Neues Tagblatt</span> on the day after that
celebration would accurately report what you said in your opening
address?</p>
<p class="pindent">You need not look at the rest of it for the moment. It is not
likely that that article is untrue or incorrect, is it?</p>
<p class="pindent">STRÖLIN: No, the article is probably correct, but I did not
remember—now looking back—that Haushofer was at that time the
deputy of Hess, for Rudolf Hess had no connection with the Deutsches
Auslands-Institut as such.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: It appears that you are saying
there, and you are saying it in a speech, that Haushofer is representing
Hess, and that Hess has been charged by the Führer with the
supreme command of all matters concerning Germans in foreign
countries. Do you understand what you are saying there?</p>
<p class="pindent">STRÖLIN: Yes, it may have been put that way at that time, but
in practice, it never happened that I received a directive of any kind
from Rudolf Hess.
<span id="Page_59" title="59"></span></p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Your institution could correctly be
said to concern itself in matters concerning Germans in foreign
countries, could it not?</p>
<p class="pindent">STRÖLIN: I did not understand the question.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Did your institution, the Deutsches
Auslands-Institut, concern itself in matters concerning Germans in
foreign countries?</p>
<p class="pindent">STRÖLIN: Yes.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Very well, I shall leave that. Will
you look down the page and omit the next...</p>
<p class="pindent">STRÖLIN: I would like to add to this point. It was the first time
that I made a speech for the Deutsches Auslands-Institut and the
speech was, of course drafted with the approval of the personalities
who were to be welcomed there. I cannot longer remember that
Haushofer was present in that capacity on that occasion and can
merely repeat my statement that as the honorary president of the
Institute I know nothing of Rudolf Hess having given directives to
the Deutsches Auslands-Institut.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: You may have known nothing
about it, but you were the new chairman of the Deutsches Auslands-Institut
at that time, were you not?</p>
<p class="pindent">STRÖLIN: No, I was not the chairman. The chairman of the
Institute was a special leader. In my capacity as Lord Mayor it was
merely one of my many extra duties to act as president of the
Institute. It is quite impossible for me to remember which personalities
I greeted at the time, and how I did it.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Please confine yourself to answering
the particular question I put to you: Were you or were you
not the chairman of the Deutsches Auslands-Institut on 20 September
1933?</p>
<p class="pindent">STRÖLIN: Yes, I was appointed to that position at that time.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: You had just been appointed because
you were a good Nazi and the Nazi Party had come to power
and was reorganizing this institution.</p>
<p class="pindent">STRÖLIN: I was appointed to this post because I was Lord Mayor
of Stuttgart and because later the city of Stuttgart was called the
“City of Germans Abroad” since, because of its history and tradition
it had always had very close connection with Germans abroad.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Very well, now, we will go on. Will
you miss out the next short paragraph and look at the paragraph
which starts off, “Deputy Gauleiter Schmidt, representing Dr. Goebbels,
stated the local Party leadership...”
<span id="Page_60" title="60"></span></p>
<p class="pindent">STRÖLIN: What page is that on?</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: It is on the same page.</p>
<p class="pindent">STRÖLIN: Page 461?</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: I beg your pardon, it is on Page
462. And it is the third paragraph in the center of the page.</p>
<p class="pindent">STRÖLIN: Yes, I found the place.</p>
<div class="blockquote">
<p class="calibre3">LT. COL. GRIFFITH-JONES: “Deputy Gauleiter Schmidt, representing
Dr. Goebbels, stated, ‘The local Party leadership
(Gauleitung) is prepared to co-operate through thick and thin
with the new officers of the Deutsches Auslands-Institut.’ ”</p>
</div>
<p class="pindent">Hess, you know, was in charge of the Party leadership, wasn’t
he—the Gauleiter? We will go on:</p>
<div class="blockquote">
<p class="calibre3">“National Socialism will demand the blood unity of all Germans
as its historic right.”</p>
</div>
<p class="pindent">Will you look now at Page 463—we will leave that—Will you
look now...</p>
<p class="pindent">STRÖLIN: May I say something in connection with this?</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: If you please, yes.</p>
<p class="pindent">STRÖLIN: The Deputy Gauleiter, Schmidt, was here purely in
his capacity as a deputy of the Gauleiter, but he was not the Deputy
of Rudolf Hess.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: No. But the point I am putting—I
will make it quite clear—is that the Gauleitung which came under
Hess was going to co-operate with your institution through thick
and thin. You appreciate that?</p>
<p class="pindent">STRÖLIN: That is obvious.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Would you look at Page 463, and
on the second paragraph:</p>
<div class="blockquote">
<p class="calibre3">“In his address the new director of the DAI, Dr. Csaki, stated:
‘We followed with deep distress the inner disunity of the German
people. Now since all that has been overcome, since we
see that all the German Folk (Volksdeutsche) organizations are
standing in one line, we are filled with a feeling of pride for
our German mother-country, a feeling of happiness: Germany
is united.’</p>
<p class="calibre3">“ ‘The feeling of adherence to the German people gives us a
happy consciousness. In the course of centuries this or that
position has been lost. We must prevent any from being lost.
It gives us a feeling of pride and self-confidence that we are
bridges for the German Lebensraum.’ ”</p>
</div>
<p class="pindent">Was that in fact what the purpose of the Deutsches Auslands-Institut
was?
<span id="Page_61" title="61"></span></p>
<p class="pindent">STRÖLIN: Dr. Csaki said in this quotation that the Germans
abroad were bridges to the German Lebensraum. This German Lebensraum
also applied, for instance, to the Germans in Hungary and
Romania and to that extent it is true when he says the Germans are
“bridges” to this Lebensraum, that is, the space in which Germans
live. This has also always been the attitude of the Deutsches Auslands-Institut;
to build bridges to the Lebensraum in which these
Germans live.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Very well. Now, have you ever
read a book by Dr. Emil Ehrlich, or seen it, entitled: <span class="it1">Die Auslands-Organisation
der NSDAP</span>? You need not look at that. Have you
ever read that book? A title of that kind?</p>
<p class="pindent">STRÖLIN: I do not think so.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Do you know that Dr. Emil Ehrlich
was the personal adviser to Bohle?</p>
<p class="pindent">STRÖLIN: I believe he was Bohle’s adjutant at one time.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Will you look at Page 305 of the
book that you have in front of you—My Lord, this passage appears
on Page 5 of the document the Tribunal has—and that is a reproduction
of Dr. Emil Ehrlich’s book. Would you look at the second
paragraph on Page 305, half way down that paragraph, starting:</p>
<div class="blockquote">
<p class="calibre3">“On 27 August 1936 the Führer designated Stuttgart as the
‘City of Germans Abroad,’ and the Gauleiter of the Auslands-Organisation
of the NSDAP assumed protection of this beautiful
city, which also houses within its walls the German Auslands-Institut,
which works in hearty co-operation with the
Auslands-Organisation.”</p>
</div>
<p class="pindent">Would I be right in saying that throughout the whole history,
from 1933 onwards, the Deutsches Auslands-Institut was working in
the heartiest co-operation with the Auslands-Organisation?</p>
<p class="pindent">STRÖLIN: This is not correct, inasmuch as there was no practical
or scientific co-operation between the Deutsches Auslands-Institut
and the Auslands-Organisation. The hearty co-operation, as I have
already mentioned, referred to the fact that the Ausland Germans
had their meetings in Stuttgart. That was the hearty co-operation
between them. There was no co-operation in practical matters since
it was not necessary.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Will you look at Page 127 of this
book? I want you to tell me, looking at the last paragraph, whether
that is an accurate report, “All persons who in the future...” this
is, I beg your pardon, a confidential report on the special schooling
work conducted by the DAI for the foreign organizations. You did
in fact, did you not, assist the foreign organizations in training their
Landesgruppenleiter and other leaders abroad?
<span id="Page_62" title="62"></span></p>
<p class="pindent">STRÖLIN: May I ask who signed this article or report?</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: No, I cannot tell you who signed
that report. I asked you a question. Did the Deutsches Auslands-Institut
assist in training leaders for the Auslands-Organisation
abroad?</p>
<p class="pindent">STRÖLIN: I am not informed on that point.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Now, just turn over to Page 128,
second paragraph, which I read to you quite shortly:</p>
<div class="blockquote">
<p class="calibre3">“The Auslands-Institut plays a part in determining the curriculum
for the training camps (Schulungslager) as well as
serving as an intermediary between the party authorities who
run these camps and the Germans from abroad who attend
them.”</p>
</div>
<p class="pindent">You still say that that report is...</p>
<p class="pindent">STRÖLIN: May I ask the date of this report?</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: I told you it is a report...</p>
<p class="pindent">STRÖLIN: I had no knowledge of this report.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Very well, I just want to ask you
one or two very short questions on the evidence that you have given
about the Defendant Von Neurath. You have told us that he was a
man of peace, with an excellent, kind character. Do you know that
on the 5th of November 1937 he attended a meeting at which Hitler
addressed the leaders of his Armed Forces? Did you ever hear of
that meeting, on the 5th of November 1937?</p>
<p class="pindent">STRÖLIN: No, I did not hear of this meeting, at least not until
I was imprisoned.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Well then, perhaps I could tell you
quite shortly what took place. Hitler said at the meeting, among
other things, that the only way out of the German difficulties was
to secure greater living space, and he said that that problem could
be solved only by force. And, having said that, he then went on to
say that he had decided to attack Austria and Czechoslovakia. You
never heard of that meeting?</p>
<p class="pindent">STRÖLIN: No, I have not heard anything of that meeting, and
concluded only later that...</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: But...</p>
<p class="pindent">STRÖLIN: May I finish my sentence?</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: I only wanted to know...</p>
<p class="pindent">STRÖLIN: I said just that Von Neurath indicated to me
that he had serious differences of opinion with Hitler. That was
toward the end of 1937. It was only later that I realized that he
must have meant the conference with Hitler and the attitude
<span id="Page_63" title="63"></span>
which he took on 5 November; however, it was only when I was in
prison that I heard through the newspapers that such a conference
actually took place.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: I shall come to all that in a
moment. I just want you to get a picture of what happened at
this meeting, and I quote four lines from the minutes of that
meeting:</p>
<div class="blockquote">
<p class="calibre3">“Hitler believed that very probably England and presumably
France had already secretly abandoned Czechoslovakia and
were satisfied that this question would one day be cleared
up by Germany.”</p>
</div>
<p class="pindent">And Hitler then went on to say that the embodiment of Czechoslovakia
and Austria would constitute a conquest of food for 5 or
6 million people, and that he visualized the compulsory immigration
of 2 million people from Czechoslovakia.</p>
<p class="pindent">Now, that is what took place at that conference. Do you know
that some 4 months later—on 12 March 1938—Von Neurath was
giving an assurance to M. Masaryk, and among other things he
assured him, on behalf of Herr Hitler, that Germany still considered
herself bound by the German-Czechoslovak Arbitration
Convention of 1925? Do you know that he said that?</p>
<p class="pindent">STRÖLIN: I do not recall it.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Can you understand, now that I
have told you that that is a fact, can you understand anybody who
had been at that conference and had heard what Hitler had said
on 5 November giving an assurance to Czechoslovakia 4 months
later in terms of that kind? Can you understand any honest man
doing that?</p>
<p class="pindent">STRÖLIN: I cannot judge the situation prevailing at that time.
I do not know from whom Von Neurath might have received an
order.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: I am not asking you to judge at
that time. I am asking you now what your opinion is of a man
who can do that sort of thing. I want you to tell the Tribunal.</p>
<p class="pindent">STRÖLIN: I cannot answer that because I do not have a comprehensive
picture of that situation.</p>
<p class="pindent">DR. VON LÜDINGHAUSEN: Mr. President, I must under any
circumstances object to this type of suggestive question. It is not
permissible to put such a question to the witness without giving
him the complete picture of how this assurance was given. The
fact is, and it is correct, that in the speech of 5 November 1937,
Hitler for the first time developed plans which were no longer
in accord with the peace policy of Herr Von Neurath, and Von
<span id="Page_64" title="64"></span>
Neurath took the opportunity—I believe in December or early in
January—to discuss this thoroughly with Hitler and point out to
him the impossibility of the policy which he apparently wanted
to embark upon and to persuade him not to carry it out. When
from Hitler’s reply he was forced to the conclusion that Hitler
would nevertheless insist on this policy which would lead to aggression
in the future he submitted his resignation. On 4 February
1938 Herr Von Neurath was permitted to resign. He no longer
participated in active politics.</p>
<p class="pindent">On 11 or 12 March, when the invasion of Austria took place,
an invasion of which Herr Von Neurath had no inkling until that
day, Hitler called him...</p>
<p class="pindent">THE PRESIDENT: Dr. Lüdinghausen, will you kindly wait?
The question was put about the 5th of March 1938, whether a man
who had heard the conference of the 5th of November 1937 could
have given the assurance of the 5th of March.</p>
<p class="pindent">DR. VON LÜDINGHAUSEN: Yes, I can also clarify that statement,
if I may. The question put by Minister Mastny was whether
any military action against Czechoslovakia was intended immediately
or soon after the invasion of Austria, and Herr Von Neurath
believed that he could, honestly and as a gentleman, answer this
question in the negative.</p>
<p class="pindent">We have to take into consideration the circumstances under
which this statement was made. First, Hitler, in his speech of
5 November 1937, spoke of the years to come. When he marched
into Austria on 12 March, that is at a time which from 5 March...</p>
<p class="pindent">THE PRESIDENT: Just one moment. We do not want to have
all this argument. The question was what was this witness’ opinion
of a man who had done that. That was all the question that was
asked, and that question is put to credit...</p>
<p class="pindent">DR. VON LÜDINGHAUSEN: Mr. President, I beg your pardon;
no one can answer that question unless he knows in what connection
it was put. Mr. Mastny asked whether the march into Austria
would entail any aggressive action against Czechoslovakia and
Von Neurath answered that question. No more and no less. He
did not want to give an answer regarding the future. The Minister
wanted to know whether in connection with the march of the
German troops into Austria any military actions against Czechoslovakia
were intended. According to the information which my
client had, he could in the given situation answer this question
in the negative with a clear conscience. This question is admissible
only if the witness is informed about what I have just said. The
point is not that he declared once and for all Germany will never
march into Czechoslovakia, but that he merely answered the Czech
<span id="Page_65" title="65"></span>
Minister Mastny’s question: Is there any danger that in connection
with the march into Austria, military measures will also be taken
against Czechoslovakia? This question he could answer the way
he did. Therefore, the question in the form in which it was put
by the British Prosecution is in my opinion not admissible.</p>
<p class="pindent">THE PRESIDENT: The Tribunal thinks the question properly
admissible.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Well, we will not pursue the
matter. I ask you just this one further question, so that I make
myself quite clear. You said in your evidence, as I wrote it down,
that the Defendant Von Neurath was well thought of, dignified
and of noble character. Having heard what I have told you, are
you still prepared to tell the Court that you think he is well thought
of, dignified, and of noble character? Is that your opinion now?
I just want to get the value of your evidence; do you see? After
what you have been told is that your opinion?</p>
<p class="pindent">STRÖLIN: It is still my opinion that Herr Von Neurath is a
man of distinguished and decent character. I cannot judge under
what circumstances he acted at the time and what considerations
prompted him to act this way.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: You say that he was in favor of
peace and did all he could to avoid a war. Do you call a deceit
of that kind doing everything possible to avoid war? Is that what
your idea of a peaceful policy is—giving assurance 4 months after
you know perfectly well that the German intention is to overrun
their country? Is that what you call doing everything to avoid war?</p>
<p class="pindent">STRÖLIN: I would like to state once more that I do not
sufficiently understand the essential points and ramifications of
this question to form a proper opinion on it. But obviously things
cannot be as simple as they have been pictured here.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Let me turn to another aspect of
this matter. We have been told at great length that he disapproved
of Hitler’s policy, and that he resigned. Do you know that, having
resigned, he was appointed Reich Protector of Bohemia-Moravia
in March 1939? Do you know that?</p>
<p class="pindent">STRÖLIN: Yes.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: That was after the remainder of
Czechoslovakia had been overrun, occupied.</p>
<p class="pindent">STRÖLIN: I said previously that Von Neurath told me that he
accepted this post very reluctantly; that he had twice refused to
accept it but later he believed that he had to make a sacrifice in
order to achieve his ends; and, as the State President Hacha told
me later, Von Neurath’s personal influence was of great benefit
<span id="Page_66" title="66"></span>
because, as Hacha told me, Von Neurath’s activity undoubtedly had
a balancing and conciliatory effect. As I said before, he was
recalled because he was too mild.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Now, you have already said it, and
we have heard it, and we have remembered it, so it is quite
unnecessary for you to say it again. Do try to answer my question
shortly. Let me ask you this question. Have you ever thought
that the reason for that appointment might have been as a reward
for his assistance in the occupation of Austria and Czechoslovakia
that had followed so shortly before?</p>
<p class="pindent">STRÖLIN: No, I never thought of that. However, if I may
mention it, I have read quite a different version in the book by
Henderson, that is, that Von Neurath had been put into that post
so that his international prestige could be discredited. I wanted
to bring in this version in order to point out that there were other
possibilities that might come into question.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Do you remember that you described
him as a disciplined, humane, and conscientious man?</p>
<p class="pindent">STRÖLIN: Yes.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Will you look at that poster.</p>
<p class="pindent">[<span class="it1">The poster was submitted to the witness.</span>]</p>
<p class="pindent">My Lord, I regret that I have not got a copy of this for the
Tribunal. It is a very short matter. It has been introduced in
the Czechoslovak report on the German occupation. I will give
Your Lordship the number: Document Number USSR-60.</p>
<p class="pindent">[<span class="it1">Turning to the witness.</span>] Do you see that this is signed by the
Defendant Von Neurath, the humane and conscientious man?</p>
<p class="pindent">STRÖLIN: Yes, I see that the Czech universities were closed
for a period of 3 years, and that nine culprits were shot. This
announcement, however, does not say, as far as I can see, exactly
why this was done. Consequently I cannot pass judgment on
the announcement, because I do not know what Von Neurath
proclaimed in it. The announcement does not tell me anything, if
I do not know the reason why the announcement was issued. That
universities were closed and nine culprits shot must have been for
convincing reasons.</p>
<p class="pindent">DR. VON LÜDINGHAUSEN: Mr. President, may I add the following?
I would like to say this in order to save time. This question
of Czechoslovakia and of this poster, with which I am also familiar,
will, of course, be dealt with, in connection with Von Neurath’s
case, and at that stage of the proceedings. I will then have the
opportunity to bring the proof that this poster did not originate
with the Defendant Von Neurath. This witness was not in Prague
<span id="Page_67" title="67"></span>
and can relate only things which he did not know of his own
experience, but which Herr Von Neurath told him. Therefore, I
believe that this question is not appropriate and is taking up time
unnecessarily, for I would have to raise objections and describe
the actual situation. We should not put questions to the witness
which, though put in good faith, are positively incorrect, that is,
questions which are based on inaccurately reported facts which
actually occurred in a different manner. I shall prove that at the
time when this poster was drafted and put up, Herr Von Neurath
was not in Prague and was not informed of what was going on
during his absence.</p>
<p class="pindent">Therefore I believe that we should not deal with this question
today, since, as I have said, the witness cannot know anything
about it from his own observation.</p>
<p class="pindent">THE PRESIDENT: It will be open to you to show that this
poster was put up when Von Neurath was not at Prague, and that
he gave no authority for it. That would clear him with reference
to this poster; but what is being put to this witness is: Assuming
that this poster was put up by Von Neurath, is it right to describe
him as a humane man? That is all the cross-examination means.</p>
<p class="pindent">DR. VON LÜDINGHAUSEN: But, the witness knows nothing of
this poster. He cannot answer the question correctly if he does
not know the ramifications, if he does not know that this poster
actually did not originate with Herr Von Neurath.</p>
<p class="pindent">THE PRESIDENT: The witness was examined at great length by
you to show he was a humane man and had a very good character.
Under such circumstances it is up to the Prosecution to put to the
witness circumstances which would indicate that he was not of that
humane character. That is all that is being done.</p>
<p class="pindent">DR. VON LÜDINGHAUSEN: In that case the most this witness
could say would be “I do not know,” or “if it is true, one cannot
call it humane.” Any one of us can say that. The witness does not
need to say it.</p>
<p class="pindent">THE PRESIDENT: The witness can say, “If this is correct it is
inconsistent with what I knew of Von Neurath.”</p>
<p class="pindent">DR. VON LÜDINGHAUSEN: He cannot and he will not say that
either, for the simple reason that he does not know the circumstances
under which this poster was published. Frankly I cannot see
the purpose of this question, for if the question is put in that way,
every decent individual will say that it is inhumane; but this would
not alter the fact that the witness would be judging facts which do
not exist and which are not true.</p>
<p class="pindent">THE PRESIDENT: Colonel Griffith-Jones, don’t you think this
is really taking up unnecessary time, if this witness doesn’t know
<span id="Page_68" title="68"></span>
anything about it? I quite see that it is the proper purpose of cross-examination
to discredit the witness.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: I am much obliged to the Tribunal.
The point of that cross-examination was, perhaps I might be allowed
to say, this: This defendant has produced a witness to give evidence
on his oath before this Tribunal. If that evidence is unchallenged,
then it goes down on the record, and there is nothing to stop this
Tribunal from regarding this witness as a man who is in a position
to give reliable evidence of that kind. This cross-examination is
rather to show that this witness, whether he is saying it truthfully
or untruthfully, is certainly inaccurate. The evidence he has given
as to the good character of this defendant does not bear investigation—that
is quite clear—and the Tribunal is not saying we are not
entitled to cross-examine as to character. However, I do not think
I need occupy the time of the Tribunal with that.</p>
<p class="pindent">THE PRESIDENT: Very well.</p>
<p class="pindent">COL. AMEN: Witness, when were you last in New York City?</p>
<p class="pindent">STRÖLIN: I was in New York in 1936.</p>
<p class="pindent">COL. AMEN: At that time you made a speech at Madison Square
Garden; is that correct?</p>
<p class="pindent">STRÖLIN: Yes.</p>
<p class="pindent">COL. AMEN: That was a rally in the Garden?</p>
<p class="pindent">STRÖLIN: It was for “German Day,” on 6 October 1936.</p>
<p class="pindent">COL. AMEN: A “German Day” rally, correct?</p>
<p class="pindent">STRÖLIN: It was the annual meeting of the Germans which took
place on 6 October.</p>
<p class="pindent">COL. AMEN: And a great percentage of the German-American
Bund, is that correct?</p>
<p class="pindent">STRÖLIN: Yes.</p>
<p class="pindent">COL. AMEN: In fact, that whole rally was held under the
auspices of the German-American Bund, was it not?</p>
<p class="pindent">STRÖLIN: The fact is, a festival committee had been commissioned
by all German clubs—I believe there are all in all two thousand
of them in New York—and these 2,000 German clubs had united
in one festival committee which organized the “German Day.” I did
not know the composition of this committee in detail.</p>
<p class="pindent">COL. AMEN: And it was at the solicitation of the German-American
Bund that you made your speech, was it not?</p>
<p class="pindent">STRÖLIN: No, it was at the solicitation of the festival committee
of the German clubs of New York.
<span id="Page_69" title="69"></span></p>
<p class="pindent">COL. AMEN: Yes, and on that committee were numerous members
of the German-American Bund; is that true? “Yes” or “no.”</p>
<p class="pindent">STRÖLIN: Yes.</p>
<p class="pindent">COL. AMEN: And as a matter of fact, there were many of the
members of your organization at that time who were active members
of the German-American Bund; is that correct?</p>
<p class="pindent">STRÖLIN: Yes.</p>
<p class="pindent">COL. AMEN: And you personally had had several conferences
with them, both here in Germany and in New York City, correct?</p>
<p class="pindent">STRÖLIN: No, that is not correct.</p>
<p class="pindent">COL. AMEN: Well, what is correct?</p>
<p class="pindent">STRÖLIN: It is correct that I was invited, but there were no
further conferences.</p>
<p class="pindent">COL. AMEN: But you do not dispute that many of the members
of your organization were at that time members of the German-American
Bund?</p>
<p class="pindent">STRÖLIN: I am not informed on that point.</p>
<p class="pindent">THE PRESIDENT [<span class="it1">To the witness</span>]: I have just taken down that
you have said that was so.</p>
<p class="pindent">COL. AMEN: Precisely.</p>
<p class="pindent">STRÖLIN: Please repeat the question.</p>
<p class="pindent">COL. AMEN: Did you not just tell me a few moments ago, in
response to a previous question, that many members of your organization
were members of the German-American Bund at the time of
your speech at the rally in Madison Square Garden?</p>
<p class="pindent">STRÖLIN: When you speak of an “organization,” do you mean
members of the German Auslands-Institut?</p>
<p class="pindent">COL. AMEN: “Your organization” is the way I put it.</p>
<p class="pindent">STRÖLIN: I had no organization; I had an institute.</p>
<p class="pindent">COL. AMEN: Exactly. And under whose auspices were you
making this speech in Madison Square Garden?</p>
<p class="pindent">STRÖLIN: I was asked to make this speech because I had shortly
before been appointed Lord Mayor of the City of Germans Abroad.
I was Lord Mayor of that city, and therefore I was asked to deliver
the address. Stuttgart was made the City of Germans Abroad, since
the Swabians furnished most of the emigrants, and for that reason
Stuttgart was to be the home city of foreign Germans.</p>
<p class="pindent">COL. AMEN: Well, is it not a fact that many members of the
Auslands-Organisation were at that time also members of the
German-American Bund? “Yes” or “no.”</p>
<p class="pindent">STRÖLIN: Yes.
<span id="Page_70" title="70"></span></p>
<p class="pindent">COL. AMEN: Is it not also a fact that at that time many
members of the Institute were also members of the German-American
Bund? Yes or no.</p>
<p class="pindent">STRÖLIN: Yes, some of these Germans had come from America;
they were students who had studied in America and returned to
Germany.</p>
<p class="pindent">COL. AMEN: And is it not also a fact that many of these
members of the German-American Bund, who were likewise
members of the Auslands-Organisation and of the Institute, were
indicted and tried and convicted for various espionage offenses
in the Federal courts of the United States? Yes or no.</p>
<p class="pindent">STRÖLIN: No, I know nothing about that.</p>
<p class="pindent">COL. AMEN: You never heard that?</p>
<p class="pindent">STRÖLIN: No, I never heard about it. I know of the case of
Kappe, but that has no connection with the Deutsche Auslands-Institut.</p>
<p class="pindent">COL. AMEN: That is one case, as a matter of fact; now, you
know some others too, don’t you?</p>
<p class="pindent">STRÖLIN: I wonder if you could give me particulars.</p>
<p class="pindent">COL. AMEN: I could, but I am asking you the questions rather
than trying to tell you the answers.</p>
<p class="pindent">STRÖLIN: I cannot remember any other case. Please
question me.</p>
<p class="pindent">COL. AMEN: No, I will go to another subject now, because it
is getting late. Are you acquainted with a Mr. Alfred Weninger—W-e-n-i-n-g-e-r?</p>
<p class="pindent">STRÖLIN: I did not understand the name. Alfred...</p>
<p class="pindent">COL. AMEN: Alfred Weninger, W-e-n-i-n-g-e-r, or however you
pronounce it.</p>
<p class="pindent">STRÖLIN: Weninger—yes I am familiar with that name.</p>
<p class="pindent">COL. AMEN: Who is he?</p>
<p class="pindent">STRÖLIN: Alfred Weninger is, to my knowledge, at present in
France. I believe he is a jurist.</p>
<p class="pindent">COL. AMEN: Well, don’t you know? Don’t you know whether
he is a jurist or not?</p>
<p class="pindent">STRÖLIN: Yes, he is employed as a jurist.</p>
<p class="pindent">COL. AMEN: What is his nationality?</p>
<p class="pindent">STRÖLIN: He is a Frenchman.</p>
<p class="pindent">COL. AMEN: Is he a friend of yours?</p>
<p class="pindent">STRÖLIN: Yes.</p>
<p class="pindent">COL. AMEN: Did you intervene on his behalf on at least one
occasion?
<span id="Page_71" title="71"></span></p>
<p class="pindent">STRÖLIN: I provided for his release from prison.</p>
<p class="pindent">COL. AMEN: That was in March 1943?</p>
<p class="pindent">STRÖLIN: No, there must be some misunderstanding. I mean
the Alfred Weninger who is a Frenchman and whom I helped
during the war so that he was not sentenced to death, and was
later released from prison. However, that took place during the
period from 1942 to 1944. I do not know another Alfred Weninger.
There may be two Alfred Weningers.</p>
<p class="pindent">COL. AMEN: No, that is correct. He was sentenced along with
12 other comrades for espionage and intelligence with the enemy.</p>
<p class="pindent">STRÖLIN: Yes, and he is the one whom I helped.</p>
<p class="pindent">COL. AMEN: And you intervened with the Attorney General
at the People’s Court?</p>
<p class="pindent">STRÖLIN: Yes, I intervened with Freisler.</p>
<p class="pindent">COL. AMEN: And also, at the Ministries of the Interior and
Justice in Berlin?</p>
<p class="pindent">STRÖLIN: I submitted to the Ministry of the Interior a memorandum
regarding conditions in Alsace, at the time, in order to
have the Alsatians pardoned.</p>
<p class="pindent">COL. AMEN: And as a result of your efforts, these people
received temporary suspension of their sentences; is that correct?</p>
<p class="pindent">STRÖLIN: Yes. I would like to mention expressly that I asked
Herr Von Neurath to intervene and it is due to a letter which he
wrote to Hitler that these Alsatians were pardoned.</p>
<p class="pindent">COL. AMEN: So that this individual, to put it mildly, is under
a considerable obligation to you at the present time? Correct?</p>
<p class="pindent">STRÖLIN: Yes, I imagine so.</p>
<p class="pindent">COL. AMEN: Well, you saved his life in effect, did you not?</p>
<p class="pindent">STRÖLIN: I also saved the lives of many others; I do not know
if the people are grateful for it or not.</p>
<p class="pindent">COL. AMEN: Well, in any event, I take it you do not question
the truth of what he might report as a conversation with you,
correct?</p>
<p class="pindent">STRÖLIN: I do not doubt that he would remember this.</p>
<p class="pindent">COL. AMEN: Do you recall having a conversation with him
in June of 1940?</p>
<p class="pindent">STRÖLIN: At the moment I cannot say unless you tell me
what it was about.</p>
<p class="pindent">COL. AMEN: Well, I will tell you what you are reported by
him to have said and I ask you whether you recall having said
that to him, either in the exact words which I put to you, or in
substance. Do you understand?
<span id="Page_72" title="72"></span></p>
<p class="pindent">STRÖLIN: Yes, I understand.</p>
<div class="blockquote">
<p class="calibre3">COL. AMEN: Here are the words: “I warn you against
National Socialism, which does not recoil before anything,
and which makes justice its servile agent. They are criminals
and I have but the one wish—to get out of it.”</p>
</div>
<p class="pindent">Did you say that to Weninger in words or in substance? “Yes”
or “no”?</p>
<p class="pindent">STRÖLIN: I did not quite understand what you said. Will
you please repeat it?</p>
<p class="pindent">COL. AMEN: You understand English, don’t you, Witness?</p>
<p class="pindent">STRÖLIN: Some. I understand just a little.</p>
<p class="pindent">COL. AMEN: As a matter of fact, you were interrogated in
English by one of our interrogators, were you not?</p>
<p class="pindent">STRÖLIN: I spoke a little English only on one occasion, but
I believe that he did not understand me correctly.</p>
<p class="pindent">COL. AMEN: And you understood perfectly well what I just
read to you, did you not?</p>
<p class="pindent">STRÖLIN: I did not fully understand the German translation
of what you said and the substance of your question is not clear
to me.</p>
<p class="pindent">COL. AMEN: Well, I shall read it to you again. But I suggest
that you are merely taking this time in order to find out what
answer you want to make. I ask you again whether you said to
Weninger in words or in substance, in June of 1940, the following:</p>
<div class="blockquote">
<p class="calibre3">“I warn you against National Socialism, which does not recoil
before anything, and which makes justice its servile agent.
They are criminals and I have but the one wish—to get out
of it.”</p>
</div>
<p class="pindent">Do you understand?</p>
<p class="pindent">STRÖLIN: Yes, I understand but I do not recall having made
that statement.</p>
<p class="pindent">COL. AMEN: Do you deny having made that statement when
I tell you that Weninger so states—Weninger, whom you have
just told us has every obligation to you?</p>
<p class="pindent">STRÖLIN: I do not remember it. It may be true that I made
critical statements, but I do not recall the wording.</p>
<p class="pindent">COL. AMEN: Do you deny having made that statement? Answer
yes or no.</p>
<p class="pindent">STRÖLIN: I deny the statement. I deny that I made it in
this form.</p>
<p class="pindent">COL. AMEN: Did you make it in substance; did you make that
statement?
<span id="Page_73" title="73"></span></p>
<p class="pindent">STRÖLIN: I cannot remember the conversation at all.</p>
<p class="pindent">COL. AMEN: Do you recall having made another statement to
Weninger in 1936 in Strasbourg—were you in Strasbourg with
Weninger in 1936?</p>
<p class="pindent">STRÖLIN: At the moment I cannot recall.</p>
<p class="pindent">COL. AMEN: But you do not deny it?</p>
<p class="pindent">STRÖLIN: I cannot recall.</p>
<p class="pindent">COL. AMEN: It is quite possible?</p>
<p class="pindent">STRÖLIN: It is possible, but I cannot recall it. I cannot at
a moment’s notice recall the date I was there.</p>
<p class="pindent">COL. AMEN: And did you not say to Weninger in Strasbourg
in 1936, in words or in substance, the following: “When I am abroad
I am ashamed to be a German”? “Yes” or “no.”</p>
<p class="pindent">STRÖLIN: It was entirely out of the question at that time,
since in the year of 1936 I was very proud of the fact that I was
a German.</p>
<p class="pindent">COL. AMEN: And then, do you deny having made that statement
to Weninger?</p>
<p class="pindent">STRÖLIN: I am quite certain that I did not make that statement
in the year 1936.</p>
<p class="pindent">COL. AMEN: When did you make it?</p>
<p class="pindent">STRÖLIN: I do not recall having made such a statement to
Weninger at all, at least not in 1936.</p>
<p class="pindent">COL. AMEN: When did you make that statement to Weninger
or anybody else? In what year did you decide to make statements
like that?</p>
<p class="pindent">STRÖLIN: I cannot recall having made such a statement at all.</p>
<p class="pindent">COL. AMEN: But you do not deny it?</p>
<p class="pindent">STRÖLIN: I frankly admit that there was a time when one
was no longer proud of Germany.</p>
<p class="pindent">THE PRESIDENT: Do the other Prosecutors wish to cross-examine?</p>
<p class="pindent">DR. SEIDL: I have no questions to put to the witness.</p>
<p class="pindent">THE PRESIDENT: Then the witness can retire. [<span class="it1">The witness
left the stand.</span>]</p>
<p class="pindent">Does that conclude your case, Dr. Seidl, or have you got any
other evidence to offer?</p>
<p class="pindent">DR. SEIDL: Yes. First, I have to read into the record the
questionnaire of the witness Alfred Hess which has arrived in the
meantime. The Tribunal has admitted his testimony in the form
of a questionnaire. I would then like to refer to various documents
<span id="Page_74" title="74"></span>
in Document Book Number 3, but before going into that and to
conclude today’s proceedings, I would like to establish upon the
request of the Defendant Hess—this refers to Volume 2 of the document
book—that Lord Simon came to the meeting as the official
representative of the British Government; I therefore read a few
sentences from Page 93 (Volume II, Page 93):</p>
<div class="blockquote">
<p class="calibre3">“Lord Simon said: ‘Herr Reichsminister, I was informed that
you had come here feeling charged with a mission and that
you wished to speak of it to someone who would be able
to receive it with Government authority. You know I am
Dr. Guthrie and therefore I come with the authority of the
Government and I shall be willing to listen and to discuss
with you as far as seems good anything you would wish
to state for the information of the Government.’ ”</p>
</div>
<p class="pindent">That was what I wished to state in completion of my reading
of the Simon minutes.</p>
<p class="pindent">THE PRESIDENT: Would you be able to finish tonight if we
went on for a few minutes or not?</p>
<p class="pindent">DR. SEIDL: Mr. President, the answers on this questionnaire are
rather long. The witness was cross-examined and I assume that
the Prosecution also intend to read the particulars of the cross-examination
and I do not believe this would be possible today.</p>
<p class="pindent">THE PRESIDENT: Very well, we will adjourn.</p>
<h3 class="calibre17 sigil_not_in_toc" id="pgepubid00006">[<span class="it1">The Tribunal adjourned until 26 March 1946 at 1000 hours.</span>]</h3>
<div class="calibre2"><span id="Page_75" title="75"></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?2bf4cae0